import {copilot} from '@cl/shared';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import {CLStore} from 'common/src/redux/store';
import {registerSkill} from 'common/src/modules/shared/copilot/skills';
import contentFeedExternalContext from '../copilot/contexts/contentFeedExternalContext';
import contentFeedAiGeneratedContext from '../copilot/contexts/contentFeedAiGeneratedContext';
import contentFeedAiGeneratedSkill from '../copilot/skills/contentFeedAiGeneratedSkill';

function initializeContentFeedsCopilot(store: CLStore) {
  copilot.uiContexts.registerUiContexts(BreadcrumbName.ContentFeedPage, {
    description:
      'The content feed page: configure external file-based feeds or AI-generated feeds, mapping, items, draft items, and content sets.',
    contexts: [contentFeedExternalContext(store), contentFeedAiGeneratedContext(store)],
  });

  if (isFlagEnabled(FeatureFlagKey.EnableCopilotContentFeedAiGenerated)) {
    registerSkill(contentFeedAiGeneratedSkill(store));
  }
}

export default initializeContentFeedsCopilot;
